import { BTable } from "bootstrap-vue";

export default {
  components: { BTable },
  props: {
    order: Object,
    disabled: Boolean,
  },
  data() {
    return {
      fields: [
        {
          key: "id",
          label: "شناسه",
        },
        {
          key: "product",
          label: "محصول",
        },
        {
          key: "single_price_without_discount",
          label: "قیمت واحد (تومان)",
        },
        {
          key: "total_price_without_discount",
          label: "قیمت کل (تومان)",
        },
        {
          key: "total_quantity",
          label: "تعداد",
        },
        {
          key: "single_discount",
          label: "تخفیف واحد (تومان)",
        },
        {
          key: "total_discount",
          label: "تخفیف کل (تومان)",
        },
        {
          key: "total_price_sold",
          label: "  قیمت نهایی (تومان)",
        },
      ],
    };
  },
};
